import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SquareUp\AddLocalSiteToLocationsController::__invoke
* @see app/Http/Controllers/SquareUp/AddLocalSiteToLocationsController.php
* @route '/api/site/{site}/square-up/add-location'
*/
const AddLocalSiteToLocationsController = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: AddLocalSiteToLocationsController.url(args, options),
    method: 'get',
})

AddLocalSiteToLocationsController.definition = {
    methods: ["get","head"],
    url: '/api/site/{site}/square-up/add-location',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SquareUp\AddLocalSiteToLocationsController::__invoke
* @see app/Http/Controllers/SquareUp/AddLocalSiteToLocationsController.php
* @route '/api/site/{site}/square-up/add-location'
*/
AddLocalSiteToLocationsController.url = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { site: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { site: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            site: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        site: typeof args.site === 'object'
        ? args.site.id
        : args.site,
    }

    return AddLocalSiteToLocationsController.definition.url
            .replace('{site}', parsedArgs.site.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SquareUp\AddLocalSiteToLocationsController::__invoke
* @see app/Http/Controllers/SquareUp/AddLocalSiteToLocationsController.php
* @route '/api/site/{site}/square-up/add-location'
*/
AddLocalSiteToLocationsController.get = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: AddLocalSiteToLocationsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SquareUp\AddLocalSiteToLocationsController::__invoke
* @see app/Http/Controllers/SquareUp/AddLocalSiteToLocationsController.php
* @route '/api/site/{site}/square-up/add-location'
*/
AddLocalSiteToLocationsController.head = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: AddLocalSiteToLocationsController.url(args, options),
    method: 'head',
})

export default AddLocalSiteToLocationsController